import { ONBOARDING_CONNECT_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';

export interface ConnectOrganizationMessageProps {
	customerName?: string;
	organizationName?: string;
	salesforceUserName?: string;
}

export const ConnectOrganizationMessage: React.FC<ConnectOrganizationMessageProps> = (props) => {
	const { customerName, organizationName, salesforceUserName } = props;

	return (
		<p>
			<b>{ customerName }</b>
			{ ONBOARDING_CONNECT_COPY.PARTIAL_WILL_LINK_TO }
			<b>{ organizationName }</b>
			{ ONBOARDING_CONNECT_COPY.PARTIAL_SALESFORCE_ORGANIZATION_USING }
			<i>{ salesforceUserName }</i>
			{ ONBOARDING_CONNECT_COPY.PARTIAL_CREDENTIALS }
		</p>
	);
};
